<template>
    <a class="btn btn-success" id="submit-work" v-on:click="handleClick">
            {{ctaText}}
    </a>
    
</template>


<script>
export default {
    name: 'RegularButton',
    props: {
        ctaText: String
    },
    methods: {
        handleClick: function() {
            this.$emit('pressed', true);
        }
    }
}
</script>


<style scoped>

    #submit-work {
        margin-top:8%;
		padding-top:9px;
		padding-bottom:9px;
		padding-left:6%;
		padding-right:6%;
        justify-content: center;
        align-self: center;
		width:40%;
		margin-bottom:0.5%;
		background-color:#f25792;
		border-color:#f25792;
		color:#fff;
        font-size:0.96rem;
        cursor: pointer;
    }
        
</style>
